import { createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid fill-height account--background" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "background--overlay" }, null, -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-xl-5 col-lg-5 col-sm-12 col-md-6" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-9 pa-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text--weight-bold text--size-1-5 ma--top-0 ma--bottom-1" }, " Welcome to Powerful Data. ")
], -1)
const _hoisted_8 = { class: "col-3 pa-0" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "card-header ma--top-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header--title login--card-title" }, " Complete your Profile ")
], -1)
const _hoisted_11 = { class: "card-content" }
const _hoisted_12 = { class: "row no-gutters" }
const _hoisted_13 = { class: "col-lg-6 col-sm-12" }
const _hoisted_14 = { class: "form-field__control" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-field__label"
}, "First Name *", -1)
const _hoisted_16 = { class: "col-lg-6 col-sm-12" }
const _hoisted_17 = { class: "form-field__control" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "Lastname",
  class: "form-field__label"
}, "Last Name *", -1)
const _hoisted_19 = { class: "form-field__control" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-field__label"
}, "Email *", -1)
const _hoisted_21 = { class: "form-field__control" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "new-password",
  class: "form-field__label"
}, "Password *", -1)
const _hoisted_23 = { class: "form-field__error--box" }
const _hoisted_24 = { class: "error--message" }
const _hoisted_25 = { class: "error--message" }
const _hoisted_26 = { class: "error--message" }
const _hoisted_27 = { class: "error--message" }
const _hoisted_28 = { class: "error--message" }
const _hoisted_29 = { class: "form-field__control" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirm-password",
  class: "form-field__label"
}, "Confirm Password *", -1)
const _hoisted_31 = {
  class: "form-field__control",
  title: "Phone number only numeric"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "form-field__label"
}, "Phone *", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "text--align-center" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn--primary btn--large"
  }, " Submit ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_focus = _resolveDirective("focus")!
  const _directive_sameAs = _resolveDirective("sameAs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                src: _ctx.logo,
                width: "120",
                alt: "Lead Pulse"
              }, null, 8, _hoisted_9)
            ])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("form", {
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.newUser()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field form-field__standard ma--top-1 pa--right-1", {
                      'form-field--is-invalid': _ctx.v$.request.firstName.$error,
                      'form-field--is-active': !_ctx.v$.request.firstName.$invalid,
                    }])
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-field__input",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.request.firstName) = $event))
                      }, null, 512), [
                        [_directive_focus],
                        [_vModelText, _ctx.request.firstName]
                      ]),
                      _hoisted_15
                    ])
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field form-field__standard ma--top-1", {
                      'form-field--is-invalid': _ctx.v$.request.lastName.$error,
                      'form-field--is-active': !_ctx.v$.request.lastName.$invalid,
                    }])
                  }, [
                    _createElementVNode("div", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-field__input",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.request.lastName) = $event))
                      }, null, 512), [
                        [_directive_focus],
                        [_vModelText, _ctx.request.lastName]
                      ]),
                      _hoisted_18
                    ])
                  ], 2)
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field form-field__standard", {
                  'form-field--is-invalid': _ctx.v$.request.email.$error,
                  'form-field--is-active': !_ctx.v$.request.email.$invalid,
                }])
              }, [
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-field__input",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.request.email) = $event)),
                    readonly: ""
                  }, null, 512), [
                    [_directive_focus],
                    [_vModelText, _ctx.request.email]
                  ]),
                  _hoisted_20
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field form-field__standard", {
                  'form-field--is-invalid': _ctx.v$.request.password.$error,
                  'form-field--is-active': !_ctx.v$.request.password.$invalid,
                }])
              }, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: "form-field__input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.request.password) = $event))
                  }, null, 512), [
                    [_directive_focus],
                    [_vModelText, _ctx.request.password]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa", _ctx.getErrors(_ctx.v$.request.password.minLength.$invalid)])
                    }, null, 2),
                    _createTextVNode(" Minimum 8 characters ")
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa", _ctx.getErrors(_ctx.v$.request.password.number.$invalid)])
                    }, null, 2),
                    _createTextVNode(" At least one number ")
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa", _ctx.getErrors(_ctx.v$.request.password.special.$invalid)])
                    }, null, 2),
                    _createTextVNode(" At least one special character ")
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa", _ctx.getErrors(_ctx.v$.request.password.uppercase.$invalid)])
                    }, null, 2),
                    _createTextVNode(" At least one Uppercase ")
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa", _ctx.getErrors(_ctx.v$.request.password.lowercase.$invalid)])
                    }, null, 2),
                    _createTextVNode(" At least one Lowercase ")
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field form-field__standard", {
                  'form-field--is-invalid': _ctx.v$.request.confirmPassword.$error,
                  'form-field--is-active': !_ctx.v$.request.confirmPassword.$invalid,
                }])
              }, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: "form-field__input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.request.confirmPassword) = $event))
                  }, null, 512), [
                    [_directive_focus],
                    [_vModelText, _ctx.request.confirmPassword],
                    [_directive_sameAs, _ctx.request]
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field form-field__standard", {
                  'form-field--is-invalid': _ctx.v$.request.phone.$error,
                  'form-field--is-active': !_ctx.v$.request.phone.$invalid,
                }])
              }, [
                _createElementVNode("div", _hoisted_31, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-field__input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.request.phone) = $event))
                  }, null, 512), [
                    [_directive_focus],
                    [_vModelText, _ctx.request.phone]
                  ]),
                  _hoisted_32
                ])
              ], 2),
              _createElementVNode("p", {
                class: _normalizeClass(["terms", {
                  'form-field--is-invalid': _ctx.v$.termsAndConditions.$error,
                  'form-field--is-active': !_ctx.v$.termsAndConditions.$invalid,
                }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.termsAndConditions) = $event)),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.termsAndConditions.$touch()))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.termsAndConditions]
                ]),
                _createTextVNode(" By clicking here, I am creating an account and agree to abide by the terms and conditions and privacy policy of " + _toDisplayString(_ctx.appName) + ", which includes protecting the rights of consumers by complying with all Federal and State laws, and to behave in a legal, ethical and responsible manner with the data that I purchase. ", 1)
              ], 2),
              _hoisted_33
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}